import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Badge } from "react-bootstrap";

const HeaderPillFilters = ({ titles = [], activeFilter, setActiveFilter }) => {
  useEffect(() => {
    if (titles && titles.length > 0 && !!activeFilter) {
      setActiveFilter({
        index: 0,
        id: titles[0].id,
      });
    }
  }, []);

  return (
    <div className="overflow-hidden d-slider1 flex-grow-1 me-0 me-md-0 mb-3 w-100">
      <Swiper
        as="ul"
        className="p-0 m-0 swiper-wrapper list-inline tableHeaderSwiper"
        modules={[Navigation]}
        data-aos="fade-up"
        data-aos-delay="700"
        slidesPerView="auto"
        spaceBetween={10}
      >
        {titles &&
          titles?.map((title, index) => {
            return (
              <SwiperSlide className="cursor-pointer" key={title?.event_id}>
                <Badge
                  pill
                  bg="light text-primary"
                  onClick={() =>
                    setActiveFilter({
                      index: index,
                      id: title?.event_id,
                    })
                  }
                  className={`border w-auto  ${
                    index === activeFilter.index
                      ? "border-primary"
                      : "border-light"
                  } `}
                >
                  {title.event_name}
                </Badge>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
};

export default HeaderPillFilters;
